<template>
  <div class="content-style">
    <app-header-public :transparentHeader="true" :hrefSignupOnPage="true"/>
    <section>
      <v-container 
          fluid 
          class="fill-height pb-16 hero__confirm__email"
      >
          <v-row align="center" justify="space-around">
              <v-col lg="6" xl="5" sm="12" xs="12" md="6">
                  <v-row justify="center">
                      <v-col :cols="$vuetify.breakpoint.lgAndUp ? 9:12" >
                          <v-container :fluid="true" :class="{ 'text-center': $vuetify.breakpoint.smAndDown }">
                              <div :class="{ 'mx-12': $vuetify.breakpoint.sm }">
                                  <p class="white--text text-h6 text-uppercase">Contabilidad automatizada</p>
                                  <h1 :class="{'text-h3':$vuetify.breakpoint.mdAndUp,'text-h5':$vuetify.breakpoint.smAndDown}" class="white--text font-weight-bold mt-5 mb-2">
                                      ¡Hola! Soy Inmatic. Tu robot contable.
                                  </h1>
                                  <p class="white--text mb-2 text--darken-3">
                                      Descubre como liberar la carga de trabajo y el tiempo que te requiere picar facturas
                                      de forma simple y ágil.
                                  </p>
                                  <h2 class="white--text mb-2">¿Qué consigues con nuestra prueba gratuita?</h2>
                                  <ul class="white--text mb-3 text--darken-3">
                                      <li>
                                          Aprovecha una solución basada en inteligencia artificial para reducir a la mitad el
                                          tiempo de contabilización de tus facturas.
                                      </li>
                                      <li>
                                          Aumenta la eficacia de tu gestoría creando un modelo de trabajo escalable.
                                      </li>
                                      <li>
                                          Motoriza de principio a fin el proceso contable.
                                      </li>
                                  </ul>
                              </div>
                          </v-container>
                      </v-col>
                  </v-row>
              </v-col>

              <v-col 
                  :order="$vuetify.breakpoint.mdAndUp ? '' : 'first'" 
                  lg="6" xl="5" sm="12" xs="12" md="6"
                  class="signup__form__column"
              >
                  <div :class="{'mx-5':$vuetify.breakpoint.mdAndDown}">
                      <v-card
                          color="#F2F1FF"
                          width="400" 
                          class="mx-auto rounded-xl py-6 px-8 lighten-5 signup__form__card"
                          elevation="3"
                          :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : ''"
                      >
                          <div class="text-center">
                            <div class="mdi-stack">
                              <v-icon class="mdi-stack-1">
                                mdi-email-outline
                              </v-icon>
                              <v-icon class="mdi-stack-2">
                                mdi-circle
                              </v-icon>                          
                            </div>
                          </div>
                          <v-card-title class="primary--text justify-center confirm__email__form__title">                            
                              <b>Revisa tu correo</b>
                          </v-card-title>
                          <v-card-text class="text-center pb-0">Le hemos enviado un email con un código de verificación</v-card-text>
                          <v-card-text class="py-0" v-if="!success"> 
                              <v-form id="confirm-email-form">
                                <v-row>
                                    <v-col> 
                                      <v-text-field 
                                        class="centered-input"
                                        id="code1"                             
                                        v-model="code1"                                                                
                                        :rules="[rules.required]"
                                        single-line
                                        :maxlength="1"                                         
                                        @paste="pasteCode"
                                        @keyup="nextFocus($event, 'code2')"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        class="centered-input"
                                        id="code2"                                                           
                                        v-model="code2"                                                                
                                        :rules="[rules.required]"
                                        single-line                                                                           
                                        :maxlength="1"
                                        ref="code2"
                                        @keyup="nextFocus($event, 'code3')"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        class="centered-input"
                                        id="code3"                             
                                        v-model="code3"
                                        :rules="[rules.required]"                                                                
                                        single-line
                                        :maxlength="1"
                                        ref="code3"
                                        @keyup="nextFocus($event, 'code4')"                                                                           
                                      ></v-text-field>
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        class="centered-input"
                                        id="code4"                             
                                        v-model="code4"
                                        :rules="[rules.required]"                                                                
                                        single-line
                                        :maxlength="1"
                                        ref="code4"
                                        @keyup="nextFocus($event, 'code5')"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col>
                                      <v-text-field
                                        class="centered-input"
                                        id="code5"                             
                                        v-model="code5"
                                        :rules="[rules.required]"                                                                
                                        single-line
                                        :maxlength="1"
                                        ref="code5"
                                      ></v-text-field>
                                    </v-col>
                                </v-row>                                                                                         
                                <p v-if="error" class="red--text text-center">{{error}}</p>
                              </v-form>
                          </v-card-text>                                                
                          <v-card-actions class="justify-center my-2 py-0" v-if="!success">
                              <v-btn large rounded elevation="0" class="px-6 mb-2 white--text font-weight-bold" color="#00BFFF" :loading='loading' @click="confirmEmail">
                                  Verificar
                              </v-btn>
                          </v-card-actions>
                          <v-card-text >
                              <p v-if="!success && !resentCode" class="link-resent-code justify-center" @click="resendCodeEmail">Solicitar nuevo código de verificación</p>
                              <p v-else-if="!success && resentCode" class="text-center">Se le ha enviado un nuevo código para verificar su cuenta. Compruebe la bandeja de entrada de su email.</p>
                              <p class="link-resent-code justify-center" @click="logout">Cerrar sesión</p>
                          </v-card-text>                                        
                      </v-card>
                  </div>
              </v-col>
          </v-row>
      </v-container>
    </section>
    
    <app-footer-public/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppHeaderPublic from "@/components/layout/AppHeaderPublic";
import AppFooterPublic from "@/components/layout/AppFooterPublic";

export default {
  name: 'ConfirmEmail',
  components: {
    AppHeaderPublic,
    AppFooterPublic,    
  },
  data() {
		return {
      loading: false,      
      error:'',
      success: false,
      resentCode: false,
      code1:'',
      code2:'',
      code3:'',
      code4:'',
      code5:'',
      rules: {
          required: value => !!value || '',
      }
    }
  },
  computed: {    
  }, 
  methods: {
    isCodeCorrect() {
      if (this.code1.length == 1 && this.code2.length == 1 && this.code3.length == 1 && this.code4.length == 1 && this.code5.length == 1) {
        return true
      } else {
        this.error = "Código incorrecto"
        return false
      }
    },
    nextFocus: function(e, s_ref) {
      if (![8, 9, 16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 46, 144].includes(e.which)){
        this.$refs[s_ref].focus();
        this.$refs[s_ref].$el.querySelector('input').select();      
      }      
    },    
    /*nextFocus: function (e) {            
      const inputs = Array.from(e.target.form.querySelectorAll('input[type="text"]'));
      const index = inputs.indexOf(e.target);
      if (index < inputs.length) {
        inputs[index + 1].focus();
        inputs[index + 1].select();
      }
    },*/
    pasteCode(evt) {
      evt.preventDefault();
      let paste_data = evt.clipboardData.getData('text/plain').trim().split('');       
      for (let i=0;i<5;i++){
        if (paste_data[i] !== undefined) {
          let el = document.getElementById("code" + (i+1));
          el.value = paste_data[i];       
          el.dispatchEvent(new Event('input'));
        }
      }
    },
    async confirmEmail() {      
        if (this.isCodeCorrect()) {
            this.error = ''
            this.resentCode = false;
            this.loading = true;
            try {
                const resp = await this.confirmEmailUser({
                    code: this.code1 + this.code2 + this.code3 + this.code4 + this.code5,
                }); 
                
                this.loading = false;
                if (resp.data['output'] && 'error' in resp.data['output']) {
                  if (resp.data.output.error.includes('InvalidConfimationCodeException')) { 
                    this.error  = "Código de verificación del email inválido";
                  }
                  else if (resp.data.output.error.includes('MaxAttemptsExceededException')) { 
                    this.error  = "Ha excedido el número máximo de intentos, puede reenviarse nuevamente el código de verificación."
                  }
                  else {
                    this.error = resp.data.output.error
                  }                  
                }
                else {
                  this.success = true;
                  this.$router.push({name: "welcome"});
                  this.$router.go();
                }                      
            } catch (error) {
                this.loading = false;
                this.error = error.message;
            }
        }
    },
    async resendCodeEmail() {
      try {
          const resp = await this.resendConfirmationEmailUser();
          if (resp.data['output'] && 'error' in resp.data['output']) {
            
            if (resp.data.output.error.includes('MaxAttemptsExceededException')) { 
              this.error = "Has sobrepasado el número máximo de reenvíos del codigo de verificación. Contacta con soporte."
            }
            else {
                this.error = resp.data.output.error;
            }            
          }
          else {
            this.resentCode = true;
          }
      } catch (error) {          
          this.error = error.message;
      }

    },
    logout() {
      this.signOut().then(() => {
        this.$router.replace({ name: 'login' }, () => {
          window.location.reload();
        });
      });
    },
    ...mapActions(["confirmEmailUser", "resendConfirmationEmailUser", "signOut"]),
  }
}
</script>

<style scoped>

    .content-style {
      height: 100%;
      margin-top:-140px;
    }
    .hero__confirm__email {
      background-image: url('/inmatic_bg_nohand.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position:relative;
      padding-top: 140px;
      padding-bottom:50px;
    }
    .signup__form__column {
        position: relative;
    }
    .signup__form__card {
        z-index: 1;
        font-family: "Roboto",sans-serif!important;
    }
    .v-text-field--outlined fieldset {
      color: rgba(0, 0, 0, 0) !important;
    }
    .signup__form__card >>> .v-input input {
      text-align: center;
      font-size:30px;
      max-height: 40px;
    }
    .signup__form__card .mdi-stack {      
      display: inline-block;
      width: 5em;
      height: 5em;
      line-height: 5em;
      vertical-align: middle;
      position:relative;
    }
    .signup__form__card .mdi-stack .mdi-stack-1, .signup__form__card .mdi-stack .mdi-stack-2 {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      text-align: center;
    }
    .signup__form__card .mdi-stack .mdi-stack-1 {
      font-size: 3em;
      color: #FFFFFF;
      z-index:1;
      top:15px;
    }
    .signup__form__card .mdi-stack .mdi-stack-2 {
      font-size: 5em;
      color: #663399;
    }
    .signup__form__card .link-resent-code {
      text-decoration: underline;
      text-align:center;
      cursor:pointer;
    }
    p {
        overflow-wrap: normal;
        word-break: normal;
    }
    ul{
        padding: 0px;
    }
    ul > li {
      margin: 0;
      list-style-type: "\003E";
      list-style-position: inside;
    }
    ul > li::marker {
      color: #33ccff;
      font-weight: bold;
    }
    .confirm__email__form__title {
      font-size: 32px;
      text-align: center;
      overflow-wrap: normal;
      word-break: normal;
      hyphens: none;
    }
    @media screen and (min-width: 600px) {
        .signup__form__curve {
            position: absolute;
            top: -5%;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
    @media screen and (max-width: 600px) {
        .confirm__email__form__title {
              margin-top: 10px;
              padding-top: 0px;
              font-size: 24px;
        }
        .hero__confirm__email {
          padding-left: 0px;
          padding-right: 0px;
        }
    }
    @media screen and (min-width: 960px) {
        .signup__form__curve {
            top: 0;
            max-width: 450px;
        }
    }
    .footer  {
      margin-top:0px !important;
    }
</style>
